/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
  name: "JobCardDetail",
  props: ["doc"],
  data: () => {
    return {};
  },
  computed: {
    statusColor() {
      if (this.doc.web_status === "Open") return "red";
      else if (this.doc.web_status === "Started") return "blue";
      else if (this.doc.web_status === "Paused") return "yellow";
      else if (this.doc.web_status === "End") return "green";
      else return "grey";
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "text-center mt-0 mb-6" }, [
      _vm._v("\n    " + _vm._s(_vm.doc.operation) + "\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pt-2 text-right" }, [
      _c(
        "span",
        {
          staticClass: "indicator-pill whitespace-nowrap",
          class: _vm.statusColor
        },
        [_c("span", [_vm._v(_vm._s(_vm.doc.web_status))])]
      )
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }, [
        _c("strong", { attrs: { id: "bom_no" } }, [
          _vm._v(_vm._s(_vm.doc.bom_no))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("strong", { attrs: { id: "work_order" } }, [
          _vm._v(_vm._s(_vm.doc.work_order))
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }, [
        _c("strong", { attrs: { id: "production_item" } }, [
          _vm._v(_vm._s(_vm.doc.production_item))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("strong", { attrs: { id: "workstation" } }, [
          _vm._v(_vm._s(_vm.doc.workstation))
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }, [
        _c("strong", { attrs: { id: "workstation" } }, [
          _vm._v(_vm._s(_vm.doc.remaining_qty))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("strong", { attrs: { id: "for_quantity" } }, [
          _vm._v(_vm._s(_vm.doc.for_quantity))
        ])
      ])
    ])
  ])
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row pt-2" }, [
      _c("div", { staticClass: "col" }, [
        _c("label", { staticClass: "mb-0", attrs: { for: "bom_no" } }, [
          _c("small", [_vm._v("BOM No.")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("label", { staticClass: "mb-0", attrs: { for: "work_order" } }, [
          _c("small", [_vm._v("Work Order")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "label",
          { staticClass: "mb-0", attrs: { for: "production_item" } },
          [_c("small", [_vm._v("Production Item")])]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("label", { staticClass: "mb-0", attrs: { for: "workstation" } }, [
          _c("small", [_vm._v("Workstation")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("label", { staticClass: "mb-0", attrs: { for: "workstation" } }, [
          _c("small", [_vm._v("Remaining Qty")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("label", { staticClass: "mb-0", attrs: { for: "for_quantity" } }, [
          _c("small", [_vm._v("Qty To Manufacture")])
        ])
      ])
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/job_card_web/components/JobCardDetail.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__